import React from "react";
import "./Text.scss";

const Text = ({ children, size='paragraph', weight=400, className = "",color,lineHeight, ...rest }) => {
    return (
        <div className={
            `Text ${size ? `Text--${size}` : ""} ${className}`} {...rest}
            style={{fontWeight:weight, color: color || "var(--font-color)", lineHeight: lineHeight}}
            >
            {children}
        </div>
    );
};

export default Text;